"use strict";
/* eslint-disable */
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2021 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorAuthContentMap = exports.PriorAuthContentSuccess = void 0;
/**
* mock responses for faq content
*/
exports.PriorAuthContentSuccess = {
    "contentItems": [
        {
            "id": "AUTHORIZATION_DENIAL_REASON_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "Please see the letter for prior authorization decision details.",
            "format": "text",
            "path": "/member/sc/content/priorauthorization/authorization_denial_reason_message",
            "created_date": "Jun 1, 2020, 8:44:37 AM EDT",
            "updated_date": "Jul 19, 2021, 10:38:12 AM EDT"
        },
        {
            "id": "AUTHORIZATION_LETTER_ERROR_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "<p dir=\"ltr\"><strong>We're sorry</strong>. <br />\r\nYour letter is currently not available to download.  Please try again later.</p>\r\n",
            "format": "html",
            "path": "/member/sc/content/priorauthorization/authorization_letter_error_message",
            "created_date": "Jun 1, 2020, 8:44:18 AM EDT",
            "updated_date": "Jul 19, 2021, 10:38:03 AM EDT"
        },
        {
            "id": "AUTHORIZATION_RENEWAL_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "The prior authorization has expired. To request a renewal, please contact your provider.",
            "format": "text",
            "path": "/member/sc/content/priorauthorization/authorization_renewal_message",
            "created_date": "Jun 1, 2020, 8:44:56 AM EDT",
            "updated_date": "Jul 19, 2021, 10:37:41 AM EDT"
        },
        {
            "id": "AUTHORIZATION_SERVICES_REQUIRING_AUTH_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "<p dir=\"ltr\">Typically, prior authorization is required for procedures such as:</p>\r\n\r\n<ol dir=\"ltr\">\r\n\t<li>Chemotherapy or Radiation Therapy (one-time notification)</li>\r\n\t<li>Hysterectomy</li>\r\n\t<li>Septoplasty (surgery to straighten nasal septum)</li>\r\n\t<li>All cosmetic surgeries, including surgeries that may be potentially cosmetic, i.e, blepharoplasty, reduction mammoplasty</li>\r\n\t<li>All investigational procedures</li>\r\n\t<li>MRI, MRA, CT and PET Scan through National Imaging Associates</li>\r\n\t<li>DME when charges are $500 or more</li>\r\n\t<li>Home health care</li>\r\n\t<li>Hospice Care</li>\r\n\t<li>Applied Behavioral Analysis related to Autism Spectrum Disorder</li>\r\n\t<li>Partial hospitalization and intensive outpatient programs</li>\r\n\t<li>Specific professional services at inpatient, outpatient and office settings</li>\r\n\t<li>Residential Treatment Centers (RTCs)</li>\r\n</ol>\r\n\r\n<p dir=\"ltr\">Other procedures may also need prior authorization. Call the number on the back of your insurance card if you have questions or contact your provider.</p>\r\n\r\n<p dir=\"ltr\"> </p>\r\n",
            "format": "html",
            "path": "/member/sc/content/priorauthorization/authorization_services_requiring_auth_message",
            "created_date": "Jun 1, 2020, 8:45:20 AM EDT",
            "updated_date": "Jul 19, 2021, 10:38:20 AM EDT"
        },
        {
            "id": "AUTH_STATUS_PERMISSIONS_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "Prior Authorization is not available ",
            "format": "text",
            "path": "/member/sc/content/priorauthorization/auth_status_permissions_message",
            "created_date": "Jun 1, 2020, 8:40:18 AM EDT",
            "updated_date": "Jul 19, 2021, 10:38:57 AM EDT"
        },
        {
            "id": "GENERAL_INFORMATION",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "There are some reasons your services may not be covered. Examples: if the services varied from what was approved in the prior authorization, if you are no longer covered in a plan, if your plan changed what it covers or if your plan requirements have yet to be satisfied (e.g., limitations, waiting periods, co-payments, deductibles, network eligibility, etc.)",
            "format": "text",
            "path": "/member/sc/content/priorauthorization/general_information",
            "created_date": "Jun 1, 2020, 8:41:38 AM EDT",
            "updated_date": "Jul 19, 2021, 10:38:38 AM EDT"
        },
        {
            "id": "IMPORTANT_INFORMATION",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "Benefits are based on member eligibility for coverage, applicable prior authorization, coverage of service or plan requirements have been satisfied. See our Frequently Asked Questions for more details.",
            "format": "text",
            "path": "/member/sc/content/priorauthorization/important_information",
            "created_date": "Jun 1, 2020, 8:42:14 AM EDT",
            "updated_date": "Jul 19, 2021, 10:38:30 AM EDT"
        },
        {
            "id": "MEMBERS_LIST_ERROR_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "<p dir=\"ltr\">We're sorry. <br />\r\nYour request currently is not available. You still can filter on Status and Date Range.</p>\r\n",
            "format": "html",
            "path": "/member/sc/content/priorauthorization/members_list_error_message",
            "created_date": "Jun 1, 2020, 8:42:32 AM EDT",
            "updated_date": "Jul 19, 2021, 10:37:31 AM EDT"
        },
        {
            "id": "PERMISSIONS_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "Based on current privacy settings, you may not be able to view prior authorizations for all family members on your policy.",
            "format": "text",
            "path": "/member/sc/content/priorauthorization/permissions_message",
            "created_date": "Jun 1, 2020, 8:41:03 AM EDT",
            "updated_date": "Jul 19, 2021, 10:37:22 AM EDT"
        },
        {
            "id": "PLEASE_NOTE_INSTRUCTIONAL_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "DEFAULT Client Business Sector Code",
            "bsc": "DEFAULT Client Business Sector Code",
            "content": "Please note: This website will display prior authorizations for behavioral health services only to the treating provider.",
            "format": "plaint/text",
            "path": "/member/sc/content/priorauthorization/please_note_instructional_message",
            "created_date": "Jun 1, 2020, 8:41:22 AM EDT",
            "updated_date": "Jul 19, 2021, 10:38:47 AM EDT"
        },
        {
            "id": "PLEASE_NOTE_INSTRUCTIONAL_MESSAGE",
            "feature": "PriorAuthorization",
            "sector": "PSX Test Code",
            "bsc": "PSX Test Code",
            "content": "Test Content for BSC Override.",
            "format": "plaint/text",
            "path": "/member/sc/content/priorauthorization/please_note_instructional_message",
            "created_date": "Jun 1, 2020, 8:41:22 AM EDT",
            "updated_date": "Jul 19, 2021, 10:38:47 AM EDT"
        }
    ]
};
exports.PriorAuthContentMap = {
    AUTHORIZATION_DENIAL_REASON_MESSAGE: {
        id: "AUTHORIZATION_DENIAL_REASON_MESSAGE",
        content: "Please see the letter for prior authorization decision details.",
        format: "text",
        path: "/member/sc/content/priorauthorization/authorization_denial_reason_message",
        created_date: "Jun 1, 2020, 8:44:37 AM EDT",
        updated_date: "Jul 19, 2021, 10:38:12 AM EDT"
    },
    AUTHORIZATION_LETTER_ERROR_MESSAGE: {
        id: "AUTHORIZATION_LETTER_ERROR_MESSAGE",
        content: "<p dir=\"ltr\"><strong>We're sorry</strong>. <br />\r\nYour letter is currently not available to download.  Please try again later.</p>\r\n",
        format: "html",
        path: "/member/sc/content/priorauthorization/authorization_letter_error_message",
        created_date: "Jun 1, 2020, 8:44:18 AM EDT",
        updated_date: "Jul 19, 2021, 10:38:03 AM EDT"
    },
    AUTHORIZATION_RENEWAL_MESSAGE: {
        id: "AUTHORIZATION_RENEWAL_MESSAGE",
        content: "The prior authorization has expired. To request a renewal, please contact your provider.",
        format: "text",
        path: "/member/sc/content/priorauthorization/authorization_renewal_message",
        created_date: "Jun 1, 2020, 8:44:56 AM EDT",
        updated_date: "Jul 19, 2021, 10:37:41 AM EDT"
    },
    AUTHORIZATION_SERVICES_REQUIRING_AUTH_MESSAGE: {
        id: "AUTHORIZATION_SERVICES_REQUIRING_AUTH_MESSAGE",
        content: "<p dir=\"ltr\">Typically, prior authorization is required for procedures such as:</p>\r\n\r\n<ol dir=\"ltr\">\r\n\t<li>Chemotherapy or Radiation Therapy (one-time notification)</li>\r\n\t<li>Hysterectomy</li>\r\n\t<li>Septoplasty (surgery to straighten nasal septum)</li>\r\n\t<li>All cosmetic surgeries, including surgeries that may be potentially cosmetic, i.e, blepharoplasty, reduction mammoplasty</li>\r\n\t<li>All investigational procedures</li>\r\n\t<li>MRI, MRA, CT and PET Scan through National Imaging Associates</li>\r\n\t<li>DME when charges are $500 or more</li>\r\n\t<li>Home health care</li>\r\n\t<li>Hospice Care</li>\r\n\t<li>Applied Behavioral Analysis related to Autism Spectrum Disorder</li>\r\n\t<li>Partial hospitalization and intensive outpatient programs</li>\r\n\t<li>Specific professional services at inpatient, outpatient and office settings</li>\r\n\t<li>Residential Treatment Centers (RTCs)</li>\r\n</ol>\r\n\r\n<p dir=\"ltr\">Other procedures may also need prior authorization. Call the number on the back of your insurance card if you have questions or contact your provider.</p>\r\n\r\n<p dir=\"ltr\"> </p>\r\n",
        format: "html",
        path: "/member/sc/content/priorauthorization/authorization_services_requiring_auth_message",
        created_date: "Jun 1, 2020, 8:45:20 AM EDT",
        updated_date: "Jul 19, 2021, 10:38:20 AM EDT"
    },
    AUTH_STATUS_PERMISSIONS_MESSAGE: {
        id: "AUTH_STATUS_PERMISSIONS_MESSAGE",
        content: "Prior Authorization is not available ",
        format: "text",
        path: "/member/sc/content/priorauthorization/auth_status_permissions_message",
        created_date: "Jun 1, 2020, 8:40:18 AM EDT",
        updated_date: "Jul 19, 2021, 10:38:57 AM EDT"
    },
    GENERAL_INFORMATION: {
        id: "GENERAL_INFORMATION",
        content: "There are some reasons your services may not be covered. Examples: if the services varied from what was approved in the prior authorization, if you are no longer covered in a plan, if your plan changed what it covers or if your plan requirements have yet to be satisfied (e.g., limitations, waiting periods, co-payments, deductibles, network eligibility, etc.)",
        format: "text",
        path: "/member/sc/content/priorauthorization/general_information",
        created_date: "Jun 1, 2020, 8:41:38 AM EDT",
        updated_date: "Jul 19, 2021, 10:38:38 AM EDT"
    },
    IMPORTANT_INFORMATION: {
        id: "IMPORTANT_INFORMATION",
        content: "Benefits are based on member eligibility for coverage, applicable prior authorization, coverage of service or plan requirements have been satisfied. See our Frequently Asked Questions for more details.",
        format: "text",
        path: "/member/sc/content/priorauthorization/important_information",
        created_date: "Jun 1, 2020, 8:42:14 AM EDT",
        updated_date: "Jul 19, 2021, 10:38:30 AM EDT"
    },
    MEMBERS_LIST_ERROR_MESSAGE: {
        id: "MEMBERS_LIST_ERROR_MESSAGE",
        content: "<p dir=\"ltr\">We're sorry. <br />\r\nYour request currently is not available. You still can filter on Status and Date Range.</p>\r\n",
        format: "html",
        path: "/member/sc/content/priorauthorization/members_list_error_message",
        created_date: "Jun 1, 2020, 8:42:32 AM EDT",
        updated_date: "Jul 19, 2021, 10:37:31 AM EDT"
    },
    PERMISSIONS_MESSAGE: {
        id: "PERMISSIONS_MESSAGE",
        content: "Based on current privacy settings, you may not be able to view prior authorizations for all family members on your policy.",
        format: "text",
        path: "/member/sc/content/priorauthorization/permissions_message",
        created_date: "Jun 1, 2020, 8:41:03 AM EDT",
        updated_date: "Jul 19, 2021, 10:37:22 AM EDT"
    },
    PLEASE_NOTE_INSTRUCTIONAL_MESSAGE: {
        id: "PLEASE_NOTE_INSTRUCTIONAL_MESSAGE",
        content: "Please note: This website will display prior authorizations for behavioral health services only to the treating provider.",
        format: "plaint/text",
        path: "/member/sc/content/priorauthorization/please_note_instructional_message",
        created_date: "Jun 1, 2020, 8:41:22 AM EDT",
        updated_date: "Jul 19, 2021, 10:38:47 AM EDT"
    }
};
//# sourceMappingURL=content-mock.js.map